import { safeGet, sanitizeFilters } from "../utils/request-helpers";
import { route } from "ziggy-js";
export const getInvoiceDetail = (invoiceID) => {
    return safeGet(route('api.v1.invoices.detail', { qbiID: invoiceID }));
};
export const getInvoices = (filters = {}) => {
    const cleanParams = sanitizeFilters(filters);
    return safeGet(route('api.v1.invoices.list'), cleanParams);
};
export const getOverdueInvoiceGroups = () => {
    return safeGet(route('api.v1.invoices.overdue'));
};
export const getUserBrandOpenInvoices = () => {
    return safeGet(route('api.v1.invoices.brand.open'));
};
